module.exports = __webpack_public_path__ + "img/1f_r_inamatsu.f4873c5d.png";